/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_From_StageInputs */

const cs_field_from_stage = /** @type {(inputs: Field_From_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí fáze`)
};

const en_field_from_stage = /** @type {(inputs: Field_From_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous stage`)
};

/**
* | output |
* | --- |
* | "Previous stage" |
*
* @param {Field_From_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_from_stage = /** @type {((inputs?: Field_From_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_From_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_from_stage(inputs)
	return cs_field_from_stage(inputs)
});